import { render, staticRenderFns } from "./SpeechRecorder.vue.js?vue&type=template&id=b038a1cc!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SpeechRecorder.vue?vue&type=template&id=b038a1cc"
import script from "./SpeechRecorder.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SpeechRecorder.vue?vue&type=script&lang=js"
export * from "./SpeechRecorder.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SpeechRecorder.vue?vue&type=script&lang=js"
import style0 from "./SpeechRecorder.vue.scss?vue&type=style&index=0&id=b038a1cc&prod&lang=scss!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SpeechRecorder.vue?vue&type=style&index=0&id=b038a1cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports